// extracted by mini-css-extract-plugin
export default {"resultsPage":"IL0R9v","noInsights":"JsEvRx","withVoucherRow":"E1nEG_","centeredContent":"T9MDwv","narrowContent":"uEG5hF","sidePanel":"zLnEfX"};